<template>
  <div id="home">
    <div class="confirm-account-wrapper speed-test" style="max-width: 800px">
      <div class="wrapper-inner" style="width: 100%">
        <div class="action-box">
          <div class="box-content" v-if="started == false && interval == null">
            <img class="light-image" src="/static/img/illustrations/placeholders/launch.svg" alt="" />
            <img class="dark-image" src="/static/img/illustrations/placeholders/launch-dark.svg" alt="" />
            <h3 class="dark-inverted" style="font-size: 27px">
              {{ $t("speedtest.title") }}
            </h3>
            <p class="dark-inverted">
              {{ $t("speedtest.description") }}
            </p>
            <div class="buttons">
              <button @click="start" class="button h-button is-primary is-raised is-rounded">
                {{ $t("speedtest.start") }}
              </button>
            </div>
          </div>
          <div class="box-content" v-if="started == false && interval != null">
            <h1 style="font-size: 100px; font-weight: bold" class="dark-inverted">
              {{ counter }}
            </h1>
          </div>

          <div class="box-content" v-if="ended == true">
            <h1 class="text-center" style="font-size: 32px; margin-bottom: 30px">
              Hesaplama Tamamlandı
            </h1>
            <h1 style="font-size: 20px">
              Dakikada Çözülebilen Soru Sayısı:
              {{ stats.questionPerMinute.toFixed(1) }}
            </h1>

            <h1 style="font-size: 20px">
              Dakikada Okunan Kelime Sayısı: {{ stats.wordPerMin.toFixed(1) }}
            </h1>

            <h1 style="font-size: 20px">
              Başarı Orani: {{ stats.totalTrue * 20 }} ({{
              stats.totalTrue
              }}
              Doğru, {{ stats.totalFalse }} Yanlış)
            </h1>
            <div style="
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-top: 20px;
              ">
              <el-button type="primary" @click="$router.back()">Geri Dön</el-button>
              <el-button type="warning" @click="answersModal = true">Cevaplarıma Gözat</el-button>
            </div>
          </div>

          <div class="box-content" v-if="started == true && ended == false">
            <p class="custom-content" v-html="question.description.join(' ')"
              style="text-align: left !important; font-size: 14px !important; color: #000;"></p>
            <strong class="d-block text-left mt-2" style="
                text-align: left;
                font-size: 14px !important;
                margin-bottom: 15px;
                color: #000;
              " v-html="question.title.join(' ')"></strong>

            <label class="radio" v-for="(option, optionIndex) in question.options" style="
                width: 100%;
                padding: 0px;
                margin-bottom: 5px;
                text-align: left;
                color: #000;
              ">
              <input type="radio" :value="optionIndex" name="aa" v-model="questions[currentQuestionIndex].answer" />
              <span></span>
              {{ option.title.join(" ") }}
            </label>

            <button @click="next" class="button h-button is-primary is-raised is-rounded">
              Sonraki Soru >
            </button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="answersModal">
      <div class="col-md-12 mb-5" v-for="(q, currentQuestionIndex) in questions" style="
          padding: 10px;
          box-shadow: 0px 0px 5px rgb(0 0 0 / 10%);
          border-radius: 10px;
        ">
        <p class="custom-content" v-html="q.description.join(' ')" style="
            text-align: left !important;
            font-size: 14px !important;
            color: black !important;
          "></p>
        <strong class="d-block text-left mt-2" style="
            text-align: left;
            font-size: 14px !important;
            margin-bottom: 15px;
          ">{{ q.title.join(" ") }}</strong>

        <label class="radio" v-for="(option, optionIndex) in q.options" style="
            width: 100%;
            padding: 0px;
            margin-bottom: 5px;
            text-align: left;
            color: #333;
          ">
          <input readonly disabled type="radio" :value="optionIndex" name="aa" />
          <span :style="{
              backgroundColor: option.isTrue
                ? 'green'
                : !option.isTrue && q.answer == optionIndex
                ? 'red'
                : '',
            }"></span>
          {{ option.title.join(" ") }}
        </label>
      </div>
      <el-button @click="answersModal = false" type="primary" round>Kapat</el-button>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "SpeedTest",
  data() {
    return {
      counter: 3,
      interval: null,
      started: false,
      timer: 0,
      timerInterval: null,
      content: null,
      ended: false,
      questions: [],
      calculated: false,
      showQuestions: false,
      currentQuestionIndex: 0,
      stats: {},
      answersModal: false,
    };
  },
  methods: {
    next() {
      if (this.questions[this.currentQuestionIndex].answer == null) {
        this.$message.error("Lütfen cevabınızı seçin.");
        return;
      }

      if (this.currentQuestionIndex + 1 == this.questions.length) {
        var totalWord = 0;

        this.questions.map((k) => {
          totalWord +=
            k.title.length +
            k.description.length +
            k.options[0].title.length +
            k.options[1].title.length +
            k.options[2].title.length +
            k.options[3].title.length;
          if (k.options.length == 5) {
            totalWord += k.options[4].title.length;
          }
        });

        var wordPerMin = (totalWord / this.timer) * 60;

        var totalTrue = this.questions.filter((x) => {
          if (x.options.findIndex((y) => y.isTrue === true) == x.answer) {
            return true;
          } else {
            return false;
          }
        }).length;

        var totalFalse = this.questions.length - totalTrue;

        var questionPerMinute = (this.questions.length / this.timer) * 60;

        this.stats = {
          wordPerMin,
          totalTrue,
          totalFalse,
          questionPerMinute,
        };

        this.end();

        return;
      }

      this.currentQuestionIndex += 1;
    },
    getOptionColor(index, option) {
      if (this.calculated == false) {
        return "";
      }

      if (this.questions[index].true_answer == option) {
        return "green";
      }

      if (
        this.questions[index].true_answer != option &&
        this.questions[index].answer == option
      ) {
        return "red !important";
      }
    },
    start() {
      this.interval = setInterval(() => {
        if (this.counter == 1) {
          clearInterval(this.interval);
          this.started = true;
          this.begin();
          return;
        }
        this.counter -= 1;
      }, 1000);
    },
    begin() {
      this.timerInterval = setInterval(() => {
        this.timer += 1;
      }, 1000);
    },
    end() {
      clearInterval(this.timerInterval);
      this.ended = true;
      this.calculate();
    },
    calculate() {
      axios
        .post("speedtest/saveExam", {
          question_ids: this.questions.map((k) => k.question_id).join(","),
          word_per_minute: this.stats.wordPerMin,
          total_time: this.timer,
          understanding_rate: this.stats.totalTrue * 20,
          question_per_minute: this.stats.questionPerMinute,
          true_answer: this.stats.totalTrue,
          false_answer: 5 - this.stats.totalTrue,
        })
        .then((res) => {
          axios.get("account/get").then((res) => {
            this.$store.state.user = res.data.data.user;
          });
        });

      this.calculated = true;
    },
  },
  async created() {
    this.$store.state.test_required_popup = false;

    var questions = (await axios.get("module/questions")).data.data;

    questions.map((k) => {
      var options = [];

      for (let index = 1; index < 6; index++) {
        if (k["o" + index] != null && k["o" + index] != "") {
          options.push({
            title: k["o" + index]
              .replace(/\s\s+/g, " ")
              .replace(/[\n\r]/g, "")
              .trim()
              .replace(/<nl\s*\/?>/gi, "<br />")
              .replace(/<n\s*\/?>/gi, "<br />")
              .split(" ")
              .filter((k) => k.trim() != ""),
            isTrue: k.true_option == "o" + index,
          });
        }
      }

      this.questions.push({
        ...k,
        id: k.question_id,
        title: k.title
          .replace(/\s\s+/g, " ")
          .replace(/[\n\r]/g, "")
          .trim()
          .replace(/<nl\s*\/?>/gi, "<br />")
          .replace(/<n\s*\/?>/gi, "<br />")
          .split(" ")
          .filter((k) => k.trim() != ""),
        description: k.description
          .replace(/\s\s+/g, " ")
          .replace(/[\n\r]/g, "")
          .trim()
          .replace(/<nl\s*\/?>/gi, "<br />")
          .replace(/<n\s*\/?>/gi, "<br />")
          .split(" ")
          .filter((k) => k.trim() != ""),
        options,
        answer: null,
      });
    });

    this.questions = _.slice(_.shuffle(this.questions), 0, 5);
  },
  computed: {
    question() {
      return this.questions[this.currentQuestionIndex];
    },
  },
};
</script>

<style lang="less">
.custom-content p {
  color: black !important;
  font-size: 16px !important;
  margin-bottom: 15px;
}

.is-dark {
  .speed-test {
    .custom-content p {
      color: white !important;
    }

    strong,
    label,
    h1 {
      color: white !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/SinavSpeedTest.vue